import React from 'react';
import Accordion from './Accordion';
import ImportExcel from './ImportExcel';

const ImportExcelAccordion = ({ onImport, defaultOpen = false }) => {
    return (
        <Accordion title="Importazione Excel" defaultOpen={defaultOpen}>
            <ImportExcel onImport={onImport} />
        </Accordion>
    );
};

export default ImportExcelAccordion; 